var _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelsius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 9.8,
    ry: 9.7,
    stroke: "url(#celsius360_symbol_2027_gradient)",
    strokeWidth: 4.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "celsius360_symbol_2027_gradient",
    x1: 12,
    y1: 23.1924,
    x2: 12,
    y2: 0.807692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363BC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelsius);
export default __webpack_public_path__ + "static/media/Celsius.847455e0dd49415e9b8b495eeca73621.svg";
export { ForwardRef as ReactComponent };